import { TaskContext } from "../context/ContextTask";
import { useContext, useState } from "react";
import Alert from "./Alert";

const initialValues = {
  title: "",
  description: "",
};
export default function TaskForm() {
  const { insertTask } = useContext(TaskContext);
  const [form, setForm] = useState(initialValues);
  const [alert, setAlert] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSaved = () => {
    if (form.title === "") {
      alert("ingrese un titulo");
      return false;
    }
    insertTask(form);
    setForm(initialValues);
    setAlert(true);
    setTimeout( () => setAlert(false), 1000);
  };

  return (
    <form>
      <h4> Agregar nueva tarea</h4>
      <div className="form-group">
        <label htmlFor="Titulo">Titulo : </label>
        <input
          maxlength={25}
          type="text"
          className="form-control"
          id=""
          placeholder=""
          name="title"
          value={form.title}
          onChange={(e) => handleChange(e)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="description">Descripcion : </label>
        <input
          type="text"
          className="form-control"
          id=""
          placeholder=""
          name="description"
          value={form.description}
          onChange={handleChange}
        />
      </div>
      {
        alert && <Alert/>
      }
      <button
        disabled={ form.title ? false : true }
        type="button"
        onClick={handleSaved}
        className="btn btn-primary mt-2"
      >
        Grabar
      </button>
    </form>
  );
}
